import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';

import GetStarted, {GetStartedButtonProps} from '@fo/designSystem/Buttons/GetStarted/GetStarted';
import Checkpoints from '@fo/components/Homepage/Checkpoints/Checkpoints';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import {fonts} from '@fo/shared/styles/variables';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';

import styles from './LookingForFinance.styles';

export enum LookingForFinanceSize {
  LG,
  SM,
}

interface Props {
  title?: string;
  text?: string;
  buttonProps?: GetStartedButtonProps;
  hideCheckpoints?: boolean;
  size: LookingForFinanceSize;
  isSkipQuoteFormAndRedirectToTide?: boolean;
}

function LookingForFinance({
  title,
  text,
  buttonProps,
  hideCheckpoints,
  size,
  isSkipQuoteFormAndRedirectToTide,
}: Props): ReactElement {
  const {formatMessage} = useIntl();

  const lookingForFinanceTitle = title || formatMessage({id: 'homepage.lookingForFinance.title'});
  const lookingForFinanceText = text || formatMessage({id: 'homepage.lookingForFinance.text'});
  const headerType = size === LookingForFinanceSize.LG ? HeaderType.H2 : HeaderType.H4;

  const isSmall = size === LookingForFinanceSize.SM;

  return (
    <div className={cx(styles.lookingForFinance)}>
      <div className={cx(styles.wrapper(isSmall))}>
        <div className={cx(styles.titleWrapper(isSmall), !hideCheckpoints && styles.showCheckpoints)}>
          <Headers headerType={headerType} alignment={fonts.alignment.LEFT} className={cx(styles.title)}>
            {lookingForFinanceTitle}
          </Headers>
          <Paragraph className={cx(styles.subtitle(isSmall))} alignment={fonts.alignment.LEFT}>
            {lookingForFinanceText}
          </Paragraph>
          <GetStarted
            buttonText={buttonProps && buttonProps.buttonText}
            url={buttonProps && buttonProps.url}
            isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
          />
        </div>
        {!hideCheckpoints && (
          <div className={cx(styles.content)}>
            <Checkpoints />
          </div>
        )}
      </div>
    </div>
  );
}

export default LookingForFinance;
